import React, {Context} from 'react'
import {DynamicComponent, GridComponentConfigProps} from '../core/_models'
import {GroupComponent} from './building-blocks/GroupComponent'
import {DateTimeComponent} from './building-blocks/DateTimeComponent'
import {LookupComponent} from './building-blocks/LookupComponent'
import {MultiselectComponent} from './building-blocks/MultiselectComponent'
import {InputComponent} from './building-blocks/InputComponent'
import {ButtonComponent} from './building-blocks/ButtonComponent'
import {CheckboxComponent} from './building-blocks/CheckboxComponent'
import {GridComponent} from './building-blocks/grid/GridComponent'
import {ImageComponent} from './building-blocks/ImageComponent'
import {PdfComponent} from './building-blocks/PdfComponent'
import {StaticTabsComponent} from './building-blocks/StaticTabsComponent'
import {TextAreaComponent} from './building-blocks/TextAreaComponent'
import {DateComponent} from './building-blocks/DateComponent'
import {LinkComponent} from './building-blocks/LinkComponent'
import {HtmlComponent} from './building-blocks/HtmlComponent'
import {FileInputComponent} from './building-blocks/FileInputComponent'
import {LogViewerComponent} from './building-blocks/LogViewerComponent'
import {DynamicTabsComponent} from './building-blocks/DynamicTabsComponent'
import {StatCardComponent} from './building-blocks/StatCardComponent'
import TreeViewComponent from './building-blocks/tree-view/TreeViewComponent'
import { TimeComponent } from './building-blocks/TimeComponent'

export function drawDynamicComponent(config: DynamicComponent, context: Context<any>) {
  switch (config.type) {
    case 'GROUP':
      return <GroupComponent config={config} context={context} key={config.id} />
    case 'DATETIME':
      return <DateTimeComponent config={config} context={context} key={config.id} />
    case 'LOOKUP':
      return <LookupComponent config={config} context={context} key={config.id} />
    case 'MULTISELECT':
      return <MultiselectComponent config={config} context={context} key={config.id} />
    case 'INPUT':
      return <InputComponent config={config} context={context} key={config.id} />
    case 'BUTTON':
      return <ButtonComponent config={config} context={context} key={config.id} />
    case 'CHECKBOX':
      return <CheckboxComponent config={config} context={context} key={config.id} />
    case 'GRID':
      return (
        <GridComponent
          config={config as unknown as GridComponentConfigProps}
          context={context}
          key={config.id}
        />
      )
    case 'IMAGE':
      return <ImageComponent config={config} context={context} key={config.id} />
    case 'PDF':
      return <PdfComponent config={config} context={context} key={config.id} />
    case 'TABS':
      return config.action != null ? (
        <DynamicTabsComponent config={config} context={context} key={config.id} />
      ) : (
        <StaticTabsComponent config={config} context={context} key={config.id} />
      )
    case 'TEXTAREA':
      return <TextAreaComponent config={config} context={context} key={config.id} />
    case 'DATE':
      return <DateComponent config={config} context={context} key={config.id} />
    case 'LINK':
      return <LinkComponent config={config} context={context} key={config.id} />
    case 'HTML':
      return <HtmlComponent config={config} context={context} key={config.id} />
    case 'FILE':
      return <FileInputComponent config={config} context={context} key={config.id} />
    case 'LOG_VIEW':
      return <LogViewerComponent config={config} context={context} key={config.id} />
    case 'STAT_CARD':
      return <StatCardComponent config={config} context={context} key={config.id} />
    case 'TREE_VIEW':
      return <TreeViewComponent key={config.id} config={config} context={context} />
    case 'TIME':
      return <TimeComponent config={config} context={context} key={config.id}/>
     // return <span>{JSON.stringify(config)}</span>
  }

  return <></>
}
